export function Loading({ loadingText }: Readonly<{ loadingText: string }>) {
  return (
    <>
      <div className="w-48 h-48 border-1 border-grey-black border-t-transparent rounded-full animate-spin"></div>
      <p className="text-gray-600 text-lg">{loadingText}</p>
    </>
  );
}
